import { render, staticRenderFns } from "./RectangleH2Icon.vue?vue&type=template&id=6c5e0268&"
import script from "./RectangleH2Icon.vue?vue&type=script&lang=js&"
export * from "./RectangleH2Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports